// IST timezone utilities
export const IST_TIMEZONE = 'Asia/Kolkata';

// Convert UTC date to IST for display
export const convertUTCToIST = (utcDateString) => {
  if (!utcDateString) return '';
  
  try {
    const utcDate = new Date(utcDateString);
    const formatter = new Intl.DateTimeFormat('en-IN', {
      timeZone: IST_TIMEZONE,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    });
    
    const istDateTime = formatter.format(utcDate);
    return `${istDateTime} IST`;
  } catch (error) {
    console.error('Error converting UTC to IST:', error);
    return utcDateString;
  }
};

// Convert UTC date to IST date only
export const convertUTCToISTDate = (utcDateString) => {
  if (!utcDateString) return '';
  
  try {
    const utcDate = new Date(utcDateString);
    const formatter = new Intl.DateTimeFormat('en-IN', {
      timeZone: IST_TIMEZONE,
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
    
    return formatter.format(utcDate);
  } catch (error) {
    console.error('Error converting UTC to IST date:', error);
    return utcDateString;
  }
};

// Get current IST time for input fields
export const getCurrentISTForInput = () => {
  const now = new Date();
  const istFormatter = new Intl.DateTimeFormat('sv-SE', {
    timeZone: IST_TIMEZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  });
  
  const istTime = istFormatter.format(now);
  return istTime.replace(' ', 'T');
};

// Convert UTC datetime to IST datetime-local format
export const convertUTCToISTForInput = (utcDateString) => {
  if (!utcDateString) return getCurrentISTForInput();
  
  try {
    const utcDate = new Date(utcDateString);
    const istFormatter = new Intl.DateTimeFormat('sv-SE', {
      timeZone: IST_TIMEZONE,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });
    
    const istTime = istFormatter.format(utcDate);
    return istTime.replace(' ', 'T');
  } catch (error) {
    console.error('Error converting UTC to IST for input:', error);
    return getCurrentISTForInput();
  }
};

// Helper function to get Story Points progress info
export const getStoryPointsColor = (points) => {
  if (points >= 2100) return { bg: 'bg-green-600', text: 'text-green-600', label: 'Elite Finisher' };
  if (points >= 1500) return { bg: 'bg-yellow-500', text: 'text-yellow-600', label: 'Monthly Finisher' };
  return { bg: 'bg-red-500', text: 'text-red-600', label: 'In Progress' };
};

// Helper function to get Story Points for a member in a challenge
export const getMemberStoryPointsForChallenge = (memberId, challengeId, submissions) => {
  return submissions
    .filter(sub => sub.member_id === memberId && sub.challenge_id === challengeId)
    .reduce((total, sub) => total + (sub.story_points_awarded || 0), 0);
};

// Backend URL configuration
export const getBackendURL = () => {
  if (window.location.hostname === 'localhost') {
    return 'http://localhost:8001';
  }
  
  if (process.env.REACT_APP_BACKEND_URL && process.env.REACT_APP_BACKEND_URL !== window.location.origin) {
    return process.env.REACT_APP_BACKEND_URL;
  }
  
  return window.location.origin;
};

export const BACKEND_URL = getBackendURL();

// Debug production backend URL issues
if (window.location.hostname !== 'localhost') {
  console.log('Production Backend URL:', BACKEND_URL);
  console.log('Frontend Origin:', window.location.origin);
  console.log('Env Variable:', process.env.REACT_APP_BACKEND_URL);
}

export const API = `${BACKEND_URL}/api`;
